import { useEffect, useState } from 'react';
import styles from './affirm-content.module.scss';
import { buildAffirmIframeSrc } from '~/modules/payment/leasing-modal/utils/get-affirm-configs.server';
import { useOrderInprogress } from '~/hooks/use-order-inprogress';
import { AffirmAPIConfig } from '~/interfaces/affirm/affirm';

interface AffirmProps {
  total: number;
}

export default function AffirmContent({ total }: AffirmProps) {
  const [iframeSrc, setIframeSrc] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const { acceptContent } = useOrderInprogress();
  useEffect(() => {
    let mounted = true;
    const acceptPageContent: AffirmAPIConfig = JSON.parse(
      (acceptContent?.connectorHtml.AcceptPageContent as string) || '{}',
    );
    async function load() {
      try {
        const { src, error } = await buildAffirmIframeSrc(
          total,
          acceptPageContent?.APIKey,
        );
        if (error) {
          if (mounted) setError(error);
          return;
        }

        if (mounted) setIframeSrc(src);
      } catch (err: unknown) {
        if (mounted) setError(String(err ?? 'Unknown error'));
      }
    }

    load();

    return () => {
      mounted = false;
    };
  }, [total, acceptContent?.connectorHtml.AcceptPageContent]);

  if (error) {
    return (
      <div className={styles.section}>
        Error loading Affirm content: {error}
      </div>
    );
  }

  return (
    <section className={styles.section}>
      {iframeSrc && (
        <iframe title="Affirm Prequalification Iframe" src={iframeSrc} />
      )}
    </section>
  );
}
